// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-763dec47]:after{content:\"*\"}input[type=color][data-v-763dec47]{-webkit-appearance:none;border:1px solid #edeef0;padding:0;overflow:hidden}input[type=color][data-v-763dec47]::-webkit-color-swatch-wrapper{padding:0}input[type=color][data-v-763dec47]::-webkit-color-swatch{border:1px solid #edeef0;padding:0;overflow:hidden}", ""]);
// Exports
module.exports = exports;
